<ng-container *ngIf="isCustom && isDocumentAvailable">
  <a role="button" (click)="openDocument(params)">
    <eds-icon [type]="regulatoryDocumentFileExtension" size="large"></eds-icon>
  </a>
</ng-container>
<p *ngIf="isCustom && !isDocumentAvailable">
  {{ "literature.NA" | translate }}
</p>
<ng-container *ngIf="thumbnailAvailable && !isCustom">
  <div [ngStyle]="{ 'width.px': 40, 'height.px': 40 }">
    <eds-image
      *ngIf="!showOnlyIcon"
      [imgSrc]="params?.data?.literatureData?.imageUrl"
      [altText]="
        params?.data?.literatureData?.imageUrl
          ? params?.data?.literatureData?.fundName
          : ''
      "
      class="spacingWrapper"
    >
    </eds-image>
    <eds-icon
      *ngIf="showOnlyIcon"
      [type]="params?.data?.literatureData?.fileExtension"
      size="normal"
    ></eds-icon>
  </div>
</ng-container>
<ng-container *ngIf="!thumbnailAvailable && !isCustom">
  <eds-icon
    [type]="params?.data?.literatureData?.fileExtension"
    size="normal"
  ></eds-icon>
</ng-container>
